"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoQuestionModalWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var InfoModal_1 = require("../modals/InfoModal");
var InfoQuestionModalWrapper = /** @class */ (function (_super) {
    __extends(InfoQuestionModalWrapper, _super);
    function InfoQuestionModalWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InfoQuestionModalWrapper.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group ".concat(this.props.className || ""), children: [(0, jsx_runtime_1.jsxs)("div", { className: "d-flex align-items-start mb-3", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("label", { children: this.props.label }) }), (0, jsx_runtime_1.jsx)(InfoModal_1.InfoModal, { className: "ml-3", title: this.props.infoTitle, children: this.props.info })] }), this.props.children] }));
    };
    return InfoQuestionModalWrapper;
}(React.Component));
exports.InfoQuestionModalWrapper = InfoQuestionModalWrapper;
//# sourceMappingURL=InfoQuestionModalWrapper.js.map